import React from 'react'
import TextField from '@mui/material/TextField'

import PasswordField from '~/client/components/PasswordField'
import CommandForm from '~/client/components/CommandForm'

export default function ChangePasswordForm({
  autoFocus = false,
}){
  const [currentPassword, setCurrentPassword] = React.useState('')
  const [newPassword, setNewPassword] = React.useState('')
  const [passwordConfirm, setPasswordConfirm] = React.useState('')
  const badConfirm = !!(newPassword && passwordConfirm && newPassword !== passwordConfirm)
  const reset = () => {
    setCurrentPassword('')
    setNewPassword('')
    setPasswordConfirm('')
  }
  return <CommandForm {...{
    command: 'users.changePassword',
    submitText: 'Update Password',
    submittingText: 'Updating Account…',
    onReset: reset,
    onSubmit(value, command) {
      command.call({ currentPassword, newPassword })
    },
    onSuccess(){
      reset()
    },
  }}>{({disabled}) =>
    <>
      <PasswordField {...{
        disabled,
        required: false,
        autoFocus: true,
        label: 'Current Password',
        value: currentPassword,
        onChange: setCurrentPassword,
      }}/>
      <PasswordField {...{
        disabled,
        required: true,
        label: 'New Password',
        value: newPassword,
        onChange: setNewPassword,
      }}/>
      <PasswordField {...{
        disabled,
        required: true,
        label: 'Password Confirmation',
        value: passwordConfirm,
        onChange: setPasswordConfirm,
        error: badConfirm,
        helperText: (badConfirm && 'passwords do not match'),
        sx: {mb: 2},
      }}/>
    </>
  }</CommandForm>
}
